export default "__VITE_ASSET__BHl$V$Bs__"